<template>
  <div>
    <v-dialog v-model="contractDocumentDialog" max-width="800">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center blue white--text py-3">
          <template>{{ $t('contract.add_contract_document') }}</template>
        </v-card-title>
        <v-card-text class="py-5">
          <!-- Content Space -->
          <v-row>
            <v-col cols="12">
              <v-row v-if="!isDisable">
                <v-col cols="6">
                  <v-card>
                    <h4 class="text-center mt-3">{{ $t('upload.upload_document') }}</h4>
                    <v-card-text>
                      <v-file-input
                        truncate-length="20"
                        @change="uploadFile"
                        solo
                        background-color="grey lighten-4"
                        flat
                        :placeholder="$t('customer.select_document')"
                        hide-details
                        v-model="tmp_input"
                        :disabled="isLoading"
                      ></v-file-input>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card>
                    <h4 class="text-center mt-3">{{ $t('project.document_template') }}</h4>
                    <v-card-text>
                      <v-select
                        :items="contractTemplates"
                        item-text="title"
                        item-value="objectId"
                        flat
                        background-color="grey lighten-4"
                        solo
                        :placeholder="$t('customer.select_document_format')"
                        prepend-icon="mdi-text-box-multiple-outline"
                        @change="chooseTemplate"
                        ref="refSelectedTemplate"
                        hide-details
                        :disabled="isLoading"
                        :no-data-text="$t('noinfo')"
                      />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <div class="mt-5">
                <h4 class="text-center">{{ $t('customer.document_list') }}</h4>
                <div v-if="!isLoading">
                  <div
                    class="flex items-center justify-between px-2 py-1 my-2 rounded shadow"
                    v-for="(file, index) in form.files"
                    :key="`file_${index}`"
                  >
                    <a :href="file.url" target="_blank">{{ file.name }}</a>
                    <v-btn
                      color="error"
                      icon
                      @click="confirmRemove('file',index)"
                      :disabled="isDisable || false"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </div>
                  <div
                    class="flex items-center justify-between px-2 py-1 my-2 rounded shadow"
                    v-for="(template, index) in form.templates"
                    :key="`template_${index}`"
                  >
                    <a @click="openTemplate(index)">{{template.title}}</a>
                    <v-btn
                      color="error"
                      icon
                      @click="confirmRemove('template',index)"
                      :disabled="isDisable || false"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </div>
                  <div
                    class="flex items-center justify-center px-2 py-1 my-1 rounded"
                    v-if="form.files.length < 1 && form.templates.length < 1"
                  >{{ $t('validate.please_add_document_file') }}</div>
                </div>
                <v-card class="justify-center py-10 d-flex" v-if="isLoading" elevation="0">
                  <v-progress-circular indeterminate size="50" color="green"></v-progress-circular>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-btn color="error" elevation="0" @click="onCancel">
            <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
          </v-btn>
          <v-btn color="success" elevation="0" @click="onSave" :disabled="isDisable || isLoading">
            <v-icon left>mdi-circle-outline</v-icon>{{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <!-- {{ contractDocuments }} -->
    </v-dialog>
    <v-dialog v-model="loadingDialogStatus" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ $t('upload.uploading') }}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <confirm-dialog-component
      :type="`error`"
      :title="$t('validate.you_want_to_delete_this_document')"
      @onOk="removeFiles()"
      v-model="isConfirmRemove"
    ></confirm-dialog-component>

    <v-dialog v-model="isContractTemplateDialog" fullscreen class="editor-dialog">
      <DocumentEditorDialog
        v-if="isContractTemplateDialog && tempContractTemplate"
        :type="isDisable ? 'preview' : 'template'"
        :projectId="projectId"
        :title="tempContractTemplate.title"
        :layout="tempContractTemplate.layout"
        :paperSetting="tempContractTemplate.paperSetting"
        @onClose="isContractTemplateDialog = false"
        @onSave="onEditorData"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import {
  FileUpload,
  ContractTemplate,
  BillingSetting,
  AreaAccountingProduct
} from "../classes";
import ConfirmDialogComponent from "./ConfirmDialog.component.vue";
import DocumentEditorDialog from "./DocumentEditorDialog.component.vue";
export default {
  components: {
    ConfirmDialogComponent,
    DocumentEditorDialog
  },
  name: "ContractsDocument",
  computed: {
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.marketId);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.marketId);
    },
    ...mapGetters({
      getContractDocument: "contractDocument/getContractDocument"
    }),
    ...mapState({
      contractTemplates: state => state.contractTemplate.contractTemplates,
      contract: state => state.contract.contract,
      customer: state => state.customer.customer
    }),
    contractDocumentDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  props: {
    value: Boolean,
    objectId: String,
    isDisable: Boolean,
    isCreate: Boolean,
    projectId: String,
    marketId: String,
    document: Object
  },
  data() {
    return {
      form: {
        projectId: this.projectId,
        templates: [],
        files: []
      },
      tmp_input: null,
      loadingDialogStatus: false,
      isLoading: false,
      isConfirmRemove: false,
      isRemoveIndex: null,
      isContractTemplateDialog: false,
      tempContractTemplate: null,
      project: null,
      market: null,
      tempTemplateObjectData: null,
      templateObjectData: null,
      isRemoveType: null,
      tempIndexFormTemplate: null,
      billingSettings: null,
      areaAccountingProducts: null
    };
  },
  async created() {
    try {
      this.isLoading = true;
      if (this.admin) {
        this.project = this.admin.project;
        this.market = this.admin.market;
      }
      if (this.employee) {
        this.project = this.employee.project;
        this.market = this.employee.market;
      }
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
    }
  },
  methods: {
    async uploadFile(e) {
      try {
        if (e) {
          this.loadingDialogStatus = true;
          const file = await FileUpload.upload(e);
          file.name = e.name;
          this.form.files.push(file);
          this.tmp_input = null;
          this.loadingDialogStatus = false;
        }
      } catch (err) {
        this.loadingDialogStatus = false;
      }
    },
    async initData() {
      try {
        this.resetForm();
        this.isLoading = true;
        await this.$store.dispatch(
          "contractTemplate/getContractTemplates",
          this.projectId
        );
        if (this.document) {
          Object.assign(this.form, this.document);
        }
        this.isLoading = false;
        this.$emit("onInit");
      } catch (e) {
        this.isLoading = false;
        console.log(e);
      }
    },
    confirmRemove(type, index) {
      this.isConfirmRemove = true;
      this.isRemoveIndex = index;
      this.isRemoveType = type;
    },
    removeFiles() {
      this.isConfirmRemove = false;
      if (this.isRemoveType == "template") {
        this.form.templates.splice(this.isRemoveIndex, 1);
      } else {
        this.form.files.splice(this.isRemoveIndex, 1);
      }
    },
    async saveData() {
      try {
        const params = this.form;
        Object.assign(this.form, {});
        return await this.$store.dispatch(
          "contractDocument/createContractDocumentNoContract",
          params
        );
      } catch (e) {
        console.log(e);
      }
    },

    async onSave() {
      this.isLoading = true;
      try {
        // const response = await this.saveData();
        this.$emit("onSave", this.form);

        this.contractDocumentDialog = false;
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        console.log(e);
      }
    },
    onCancel() {
      try {
        this.contractDocumentDialog = false;
        this.$emit("onCancel", this.form);
      } catch (e) {
        console.log(e);
      }
    },
    resetForm() {
      this.form = {
        projectId: this.projectId,
        templates: [],
        files: []
      };
      this.tmp_input = null;
    },
    chooseTemplate(id) {
      this.tempIndexFormTemplate = null;
      this.tempContractTemplate = this.contractTemplates.find(
        d => d.objectId === id
      );
      this.$refs["refSelectedTemplate"].reset();
      this.$refs["refSelectedTemplate"].blur();
      setTimeout(() => {
        this.isContractTemplateDialog = true;
      }, 200);
    },
    openTemplate(index) {
      this.tempIndexFormTemplate = index;
      this.tempContractTemplate = this.form.templates[index];
      setTimeout(() => {
        this.isContractTemplateDialog = true;
      }, 200);
    },
    onEditorData(data) {
      this.isLoading = true;
      if (this.tempIndexFormTemplate || this.tempIndexFormTemplate == 0) {
        this.form.templates[this.tempIndexFormTemplate] = {
          title: data.title,
          layout: data.layout,
          paperSetting: data.paperSetting
        };
      } else {
        this.form.templates.push({
          title: data.title,
          layout: data.layout,
          paperSetting: data.paperSetting
        });
      }
      setTimeout(() => {
        this.isLoading = false;
      }, 200);
    }
  },
  watch: {
    value(data) {
      if (data) {
        this.initData();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
